import React from 'react'
import { styled } from '@mui/material'
import { ForwardStatus, MessageDescriptor } from './components'
import {
  MessagePreviewDescriptorContainer,
  MessagePreviewInfoContainer,
  MessagePreviewInfoRow,
  MessagePreviewThumbnail,
  MessagePreviewMessageTypeIconMap,
  MessagePreviewRoot,
  MessagePreviewSkeleton,
  MessagePreviewVerticalSideBox,
} from '$common/messsage-preview'
import { getMessageByIid } from '$logic/message'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { ForwardSmallIcon } from '$common/icons'

const StyledForwardIcon = styled(ForwardSmallIcon)`
  width: 20px;
  height: 18px;
  /* @noflip */
  margin: -2px 0 0 4px;
`

interface Props {
  iids: number[]
  roomId: string
}

export function ForwardContent({ iids, roomId }: Props) {
  const { loading, value: messages } = useAsyncFunction(
    () => Promise.all(iids.map(iid => getMessageByIid(roomId, iid))),
    [roomId, iids.join('')],
  )

  if (!iids || iids.length < 1) return null

  if (!messages || !messages.length) return null

  const undeletedMessages = messages.filter(
    message => !message.patches?.deleted,
  )

  if (undeletedMessages.length < 1) return null

  const firstMessage = undeletedMessages[0]
  const MessageTypeIcon =
    undeletedMessages.length === 1 &&
    MessagePreviewMessageTypeIconMap[firstMessage.type]

  const hasTypeIcon = !!MessageTypeIcon

  return (
    <MessagePreviewRoot style={loading ? {} : { cursor: 'pointer' }}>
      <MessagePreviewVerticalSideBox />

      {loading ? (
        <MessagePreviewSkeleton />
      ) : (
        <>
          {undeletedMessages.length === 1 && (
            <MessagePreviewThumbnail message={firstMessage} />
          )}

          <MessagePreviewInfoContainer>
            <MessagePreviewInfoRow>
              <StyledForwardIcon />

              <ForwardStatus messages={undeletedMessages} />
            </MessagePreviewInfoRow>

            <MessagePreviewInfoRow>
              {hasTypeIcon && (
                <MessageTypeIcon
                  sx={{ width: '20px', height: '16px', color: 'gray' }}
                />
              )}
              <MessagePreviewDescriptorContainer hasMarginToIcon={hasTypeIcon}>
                <MessageDescriptor messages={messages} />
              </MessagePreviewDescriptorContainer>
            </MessagePreviewInfoRow>
          </MessagePreviewInfoContainer>
        </>
      )}
    </MessagePreviewRoot>
  )
}

ForwardContent.defaultProps = {}
